import type { IProductEnrichment } from '~~/lib/ContentfulService';
import type { ParsedPdpBannerConfiguration } from '~/utils/pdpBanner/configurationSchema';
import { parsePdpBannerConfiguration } from '~/utils/pdpBanner/parsePdpBannerConfiguration';
import { isEntryOfContentType } from '~/utils/guards/isEntryOfContentType';

export type PdpBannerPresentation = Omit<
  ParsedPdpBannerConfiguration,
  'attributeConditions'
>;

export const getProductEnrichmentPdpBanners = (
  productEnrichments: readonly IProductEnrichment[]
): PdpBannerPresentation[] => {
  return productEnrichments.flatMap((enrichment) =>
    (enrichment.fields.contentSlotBannerAboveHeader ?? []).flatMap((entry) => {
      if (
        !isEntryOfContentType(entry, 'technicalComponent') ||
        entry.fields.type !== 'pdpBanner'
      ) {
        return [];
      }

      const parsed = parsePdpBannerConfiguration(entry.fields.configuration);
      if (!parsed.success) {
        return [];
      }

      const { attributeConditions: _attributeConditions, ...presentation } =
        parsed.data;

      return [presentation];
    })
  );
};

export const filterVisiblePdpBanners = (
  banners: readonly PdpBannerPresentation[],
  richTextByKey: Record<string, unknown>,
  suppressed: boolean
): PdpBannerPresentation[] =>
  suppressed
    ? []
    : banners.filter((banner) => richTextByKey[banner.dictKey] !== undefined);
